import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isFollowUpMessage, isStreamAnswerPart, isStreamError, isStreamResponse } from '@atlassian/conversation-assistant-service';
import { isUHTraceAnalyzingState, isUHTraceContentSearch } from './types';
export var getUHUpdatedMessage = function getUHUpdatedMessage(streamMessage, currentMessage) {
  if (isUHTraceContentSearch(streamMessage)) {
    var _streamMessage$messag;
    return {
      type: 'CONTENT_SEARCH',
      content: ((_streamMessage$messag = streamMessage.message) === null || _streamMessage$messag === void 0 ? void 0 : _streamMessage$messag.formulated_query) || ''
    };
  }
  if (isUHTraceAnalyzingState(streamMessage)) {
    var _streamMessage$messag2;
    return {
      type: 'ANALYSING_STATE',
      content: ((_streamMessage$messag2 = streamMessage.message) === null || _streamMessage$messag2 === void 0 ? void 0 : _streamMessage$messag2.sources) || ''
    };
  }
  if (isStreamAnswerPart(streamMessage)) {
    return {
      type: 'ANSWER_PART',
      content: _objectSpread(_objectSpread({}, currentMessage), {}, {
        content: currentMessage.content.toString() + streamMessage.message.content
      })
    };
  }
  if (isStreamResponse(streamMessage)) {
    return {
      type: 'FINAL_RESPONSE',
      content: _objectSpread({}, streamMessage.message.message)
    };
  }
  if (isStreamError(streamMessage)) {
    return {
      type: 'ERROR'
    };
  }
  if (isFollowUpMessage(streamMessage)) {
    var _streamMessage$messag3, _streamMessage$messag4;
    return {
      type: 'FOLLOW_UP_QUERIES',
      content: (_streamMessage$messag3 = (_streamMessage$messag4 = streamMessage.message.follow_ups) === null || _streamMessage$messag4 === void 0 ? void 0 : _streamMessage$messag4.map(function (f) {
        return f.text;
      })) !== null && _streamMessage$messag3 !== void 0 ? _streamMessage$messag3 : []
    };
  }
  return null;
};